import script from "./SearchPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./SearchPanel.vue?vue&type=script&setup=true&lang=ts"

import "./SearchPanel.vue?vue&type=style&index=0&id=6ec7bef7&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ec7bef7"]])

export default __exports__